        <script setup>
        import { ref, onMounted } from 'vue';
        import axios from 'axios';
        import DataTable from 'primevue/datatable';
        import Column from 'primevue/column';
        import Toast from 'primevue/toast';
        import { useToast } from 'primevue/usetoast';
        import authHeader from '../services/AuthHeaderAdmin';
        
        const products = ref([]);
        const isLoading = ref(false);
        const toast = useToast();
        
        const fetchProducts = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(process.env.VUE_APP_BACKEND_URL +  'produits', { headers: authHeader() }); // Replace with your backend endpoint
                products.value = response.data;
            } catch (error) {
                console.error('Erreur lors de la récupération des produits :', error);
            } finally {
                isLoading.value = false;
            }
        };
        
        const updateProductQuantity = async (productId, quantite_restante) => {
            try {
                await axios.post(process.env.VUE_APP_BACKEND_URL + 'produits/update', { id:productId, quantite_restante:quantite_restante }, { headers: authHeader() }); // Replace with your backend endpoint
                const product = products.value.find(p => p.id === productId);
                if (product) {
                    product.quantite_restante = quantite_restante;
                }
                toast.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Quantité du produit mise à jour avec succès.',
                    life: 3000
                });
            } catch (error) {
                console.error('Erreur lors de la mise à jour de la quantité du produit :', error);
                toast.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Impossible de mettre à jour la quantité du produit.',
                    life: 3000
                });
            }
        };
        
        onMounted(() => {
            fetchProducts();
        });
        </script>
<template>
    <div class="p-4">
        <h1>Gestion des produits</h1>
        <div class="p-4">
            <Toast />
            <DataTable :value="products" :loading="isLoading" dataKey="id" responsiveLayout="scroll">
                <template #empty>
                    <div class="p-4 text-center text-gray-500">Aucun produit disponible.</div>
                </template>
                <Column field="nom" header="Produit"></Column>
                
                <Column header="Quantité">
                    <template #body="slotProps">
                        <div>
                            <input
                                type="number"
                                min="0"
                                v-model.number="slotProps.data.quantite_restante"
                                style="width: 80px"
                            />
                        </div>
                    </template>
                </Column>
                <Column header="Actions">
                    <template #body="slotProps">
                        <button @click="updateProductQuantity(slotProps.data.id, slotProps.data.quantite_restante)">
                            Enregistrer
                        </button>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>
